var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoulTripCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 15C8.25 10.8579 11.6079 7.5 15.75 7.5C17.7391 7.5 19.6468 8.29018 21.0533 9.6967C22.4598 11.1032 23.25 13.0109 23.25 15C23.25 19.1421 19.8921 22.5 15.75 22.5C11.6079 22.5 8.25 19.1421 8.25 15ZM12.54 18.8325L19.5825 11.79C19.7256 11.614 19.7125 11.3583 19.5521 11.1979C19.3917 11.0375 19.136 11.0244 18.96 11.1675L11.9175 18.21C11.7469 18.3824 11.7469 18.6601 11.9175 18.8325C12.0031 18.9126 12.1153 18.958 12.2325 18.96C12.3478 18.96 12.4585 18.9141 12.54 18.8325Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoulTripCard);
export default __webpack_public_path__ + "static/media/FoulTripCard.4f8a58ce08ae41039509db5f9ccc5499.svg";
export { ForwardRef as ReactComponent };